import { SamplerFunction } from "./artistWebgl";
import { Plane3D, PointVector3D } from "./geometry";
import { Box } from "./geometryShapes";
import './resources/fonts.css';

export const matrixLayoutFunction: SamplerFunction = ({context, storage, canvasWidth, canvasHeight, parameters}) => {
    const chars = '1234567890ABCDEFGHIJKLMNOPQRSUTVWXYZabcd';
    const sizeParameter = parameters?.find(parameter => parameter.name == 'Size')?.value!;
    const newCellHeight = sizeParameter * 16 + 8;
    const newCellWidth  = newCellHeight * 0.6;

    if (storage.width != canvasWidth || storage.height != canvasHeight || storage.cellHeight !== newCellHeight) {

        const oldCols = storage.cols || 0;
        const oldRows = storage.rows || 0;
        const oldGrid = storage.grid || [];

        storage.gridDrawn = false;
        storage.width = canvasWidth;
        storage.height = canvasHeight;

        storage.cellHeight = newCellHeight;
        storage.cellWidth = newCellWidth;

        storage.cols = Math.floor(canvasWidth / newCellWidth);
        storage.rows = Math.floor(canvasHeight / newCellHeight);
        storage.borderLeft = (canvasWidth - (storage.cols * newCellWidth)) / 2;
        storage.borderTop = (canvasHeight - (storage.rows * newCellHeight)) / 2;

        let newGrid = Array.from({ length: storage.rows }, () => Array.from({ length: storage.cols }, () => chars[Math.floor(Math.random() * chars.length)]));

        for (let y = 0; y < Math.min(oldRows, storage.rows); y++) {
            for (let x = 0; x < Math.min(oldCols, storage.cols); x++) {
                newGrid[y][x] = storage.grid[y][x];
            }
        }
        storage.grid = newGrid;
    }

    if (!storage.fontLoaded) {
        document.fonts.load('10pt "MatrixCodeFont"').then(() => {
            storage.fontLoaded = true;
        }).catch(error => {
            console.error('Font failed to load:', error);
        });
    }
    
    if (!storage.gridDrawn && storage.fontLoaded) {
        context.fillStyle = "black";
        context.fillRect(0, 0, canvasWidth, canvasHeight);
        context.font = `${storage.cellHeight * 1.10}px MatrixCodeFont`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillStyle = 'green';
        for (let y = 0; y < storage.rows; y++) {
            for (let x = 0; x < storage.cols; x++) {
                context.fillText(
                    storage.grid[y][x],
                    storage.borderLeft + x * storage.cellWidth + storage.cellWidth / 2 - storage.cellHeight * 0.03,
                    storage.borderTop + y * storage.cellHeight + storage.cellHeight / 2 + storage.cellHeight * 0.2
                );
            }
        }
        storage.gridDrawn = true;
    } else if (storage.gridDrawn && storage.fontLoaded) {
        const updatePercentage = 0.003;
        const totalCells = storage.cols * storage.rows;
        const numUpdates = Math.floor(totalCells * updatePercentage);
        for (let i = 0; i < numUpdates; i++) {
            const x = Math.floor(Math.random() * storage.cols);
            const y = Math.floor(Math.random() * storage.rows);
            const newChar = chars[Math.floor(Math.random() * chars.length)];
            storage.grid[y][x] = newChar;

            context.fillStyle = "black";
            context.fillRect(storage.borderLeft + x * storage.cellWidth, storage.borderTop + y * storage.cellHeight, storage.cellWidth, storage.cellHeight);

            context.fillStyle = 'green';
            context.fillText(
                newChar,
                storage.borderLeft + x * storage.cellWidth + storage.cellWidth / 2 - storage.cellHeight * 0.03,
                storage.borderTop + y * storage.cellHeight + storage.cellHeight / 2 + storage.cellHeight * 0.2
            );
        }
    }
}

export const roundFrequencyVisualizer: SamplerFunction = ({context, storage, canvasWidth, canvasHeight, parameters, audioReactiveParameters, time}) => {
    const centerX = canvasWidth / 2;
    const centerY = canvasHeight / 2;
    const radius = canvasHeight / 5;
    const minRadius = canvasHeight / 60;
    const maxRadius = canvasHeight / 4;

    context.clearRect(0, 0, canvasWidth, canvasHeight);

    const bars = audioReactiveParameters? 40: 0;
    const angleStep = Math.PI * 2 / bars;
    context.lineWidth = canvasHeight / 120;
    context.lineCap = "round";
    context.strokeStyle = 'rgba(255,255,255,0.5)';
    
    for (let i = 0; i < bars; i++) {
        const amplitude = audioReactiveParameters!.levels[Math.floor((audioReactiveParameters!.levels.length / bars)) * i] / 255;
        const lineLength = radius + minRadius + amplitude * (maxRadius - minRadius);
        const angle = angleStep * i - Math.PI / 2 + time / 10000;

        const x1 = centerX + radius * Math.cos(angle);
        const y1 = centerY + radius * Math.sin(angle);
        const x2 = centerX + lineLength * Math.cos(angle);
        const y2 = centerY + lineLength * Math.sin(angle);

        //context.strokeStyle = `hsl(${i / bars * 360}, 100%, 50%)`;
        context.beginPath();
        context.moveTo(x1, y1);
        context.lineTo(x2, y2);
        context.stroke();
    }
}